(function () {
	'use strict';

	angular
		.module('wizard-english-test.directives')
		.directive('header', Header)

	/** @ngInject */
	function Header(PATHS) {
		function HeaderController() {
			const vm = this;

		}

		return {
			bindToController: true,
			controller: HeaderController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`
		}
	}
}());